import {Component, Input, OnInit, Output} from '@angular/core';
import {PlayersService} from "../../../services/players.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {EventEmitter} from '@angular/core';
import {
  PlayerStatsModalContentComponent
} from "../../player-stats-modal/player-stats-modal-content/player-stats-modal-content.component";
import {size} from "lodash";
import {
  PlayerVideoModalComponent
} from "../../player-video-modal/player-video-modal.component";

@Component({
  selector: 'app-player-summary',
  templateUrl: './player-summary.component.html',
  styleUrls: ['./player-summary.component.scss']
})
export class PlayerSummaryComponent implements OnInit {

  @Input() playerSummaryObject;
  @Input() playerPhoto;
  @Output() outputClickOnVideos: EventEmitter<any> = new EventEmitter();

  private _playerSummaryStatsObject;
  private _dataFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }

  constructor(
    private modalService: NgbModal,
    private playersService: PlayersService,
  ) { }

  ngOnInit(): void {
    this.playersService.getPlayerSummaryStats().subscribe((response) => {
      this.playerSummaryStatsObject = response;
    });
  }


  primitiveDataFormatter(primitiveData) {
    return primitiveData || '-';
  }
  dataOrEmptyDataFormatter(primitiveData) {
    return primitiveData || '';
  }
  dataOrZeroDataFormatter(primitiveData) {
    return primitiveData || '0';
  }
  getPlayerSummaryObject() {
    return this.playerSummaryObject;
  }

  get playerSummaryStatsObject() {
    return this._playerSummaryStatsObject;
  }

  set playerSummaryStatsObject(object) {
    this._playerSummaryStatsObject = object;
  }

  getPlayerAge() {
    return this.primitiveDataFormatter(this.getPlayerSummaryObject()?.age);
  }

  getPlayerBirthdate() {
    // return this.primitiveDataFormatter(this.getPlayerSummaryObject()?.birthdate);
    // @ts-ignore
    return new Date(this.getPlayerSummaryObject()?.birthdate).toLocaleDateString(undefined, this._dataFormatOptions);
  }

  getPlayerCountry() {
    return this.dataOrEmptyDataFormatter(this.getPlayerSummaryObject()?.city?.region?.country?.name);
  }

  getPlayerCity() {
    return this.dataOrEmptyDataFormatter(this.getPlayerSummaryObject()?.city?.name);
  }

  getPlayerCountTournaments() {
    return this.dataOrZeroDataFormatter(this.playerSummaryStatsObject?.tournaments_amount);
  }

  getPlayerCountDuelSeries() {
    return this.dataOrZeroDataFormatter(this.getPlayerSummaryObject()?.count_duel_series);
  }

  getPlayerCountWinnerDuelSeries() {
    return this.dataOrZeroDataFormatter(this.playerSummaryStatsObject?.duel_series_wins_amount);
  }

  getPlayerCountLooserDuelSeries() {
    return this.dataOrZeroDataFormatter(this.playerSummaryStatsObject?.duel_series_looses_amount);
  }

  getPlayerCue() {
    return this.primitiveDataFormatter(this.getPlayerSummaryObject()?.cue);
  }

  getPlayerTrainer() {
    return this.primitiveDataFormatter(this.getPlayerSummaryObject()?.trainer?.first_name) + ' ' +
           this.dataOrEmptyDataFormatter(this.getPlayerSummaryObject()?.trainer?.last_name);
  }

  getVideoCount() {
    return this.primitiveDataFormatter(this.playerSummaryStatsObject?.video_amount);
  }

  getPlayerCountryCode() {
    return this.getPlayerSummaryObject()?.city?.region?.country?.a2code || '';
  }

  getPlayerTitle() {
    return this.dataOrEmptyDataFormatter(this.getPlayerSummaryObject()?.full_title);
  }

  getTrainerId() {
    return this.dataOrEmptyDataFormatter(this.getPlayerSummaryObject()?.trainer?.id);
  }

  hasVideo() {
    return Number(this.playerSummaryStatsObject?.video_amount);
  }

  playerTrainerClickHandler() {
    if (!this.getTrainerId())
      return;
    this.playersService.playerId = parseInt(this.getTrainerId());
    const modalRef = this.modalService.open(PlayerStatsModalContentComponent, {
      size: 'lg',
    });
  }

  playerVideoClickHandler() {
    if (!this.hasVideo())
      return;
    this.outputClickOnVideos.emit();
  }

}
